import { FC } from 'react';

import { Box } from '@base-app';
import { StyledSectionContainer, StyledSectionTitle } from './Section.styles';
import { SectionProps } from './Section.types';

const Section: FC<SectionProps> = ({ children, css, cssHeader, cssTitle, header, title, subtitle, cssSubtitle }) => {
  return (
    <StyledSectionContainer css={{ ...css }}>
      {header && (
        <Box css={{ ...cssHeader }} data-testid="section-header">
          {header}
        </Box>
      )}
      {title && (
        <StyledSectionTitle css={{ ...cssTitle }} data-testid="section-title">
          {title}
        </StyledSectionTitle>
      )}
      {subtitle && (
        <StyledSectionTitle css={{ ...cssSubtitle }} data-testid="section-subtitle">
          {subtitle}
        </StyledSectionTitle>
      )}
      <Box data-testid="section-content">{children}</Box>
    </StyledSectionContainer>
  );
};

export default Section;
